const currentTimezone = () => {
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    const timezoneMapping = {
        "Asia/Rangoon": "Asia/Yangon",
    };

    return timezoneMapping[timezone] || timezone;
};

export { currentTimezone };
